import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import Login from '../Pages/Auth/Login/Login';

export const AuthRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/login" element={
      <Layout activePage='login' menuActive={menuActive} setMenuActive={setMenuActive} showHeader={false}>
        <Login />
      </Layout>
    } />
  </>
);
